export const LOGOUT = 'LOGOUT'
export const LOGIN = 'LOGIN'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_NEWS = 'SET_NEWS'
export const SET_SLIDE = 'SET_SLIDE'
export const SET_COMPANIES = 'SET_COMPANIES'
export const SET_ALLIANCES = 'SET_ALLIANCES'
export const UPDATEUSER = 'UPDATEUSER'
export const CLEAR_FIRST_BUY = 'CLEAR_FIRST_BUY'



// WEBPACK FOOTER //
// ./src/store/home/mutations_types.js